import { NotificationStatuses } from 'constants/notifications';

import { Typography } from 'shared/mui/Typography';
import { useDownloadReconciliationResult } from 'shared/widgets/Notification/hooks/useDownloadReconciliationResult';
import { NotificationPopperListItemFile } from 'shared/widgets/Notification/NotificationPopper/NotificationPopperListItem/components/NotificationPopperListItemFile/NotificationPopperListItemFile';
import { Notification, NotificationBodyReconciliation } from 'types/embedded/notification';

type Props = {
  notification: Notification<NotificationBodyReconciliation>;
  onSuccess: () => void;
  dataId: string;
};

export const NotificationPopperListItemReconciliation: React.FC<Props> = ({
  notification,
  onSuccess,
  dataId,
}) => {
  const { status, content } = notification.body;

  const { downloadResult, isPending } = useDownloadReconciliationResult({
    notificationId: notification.id,
    jobId: content.jobId,
    fileExtension: content.fileExtension,
    fileUrl: content.fileUrl,
    onSuccess,
  });

  return (
    <NotificationPopperListItemFile
      createdAt={content.completedAt}
      dataId={dataId}
      isDownloading={isPending}
      notification={notification}
      onDownload={downloadResult}
      primary={
        <>
          <Typography component="span">Файл с результатами автосверки</Typography>
          {status === NotificationStatuses.Done && (
            <Typography component="p" sx={{ marginTop: '8px' }}>
              Автосверка завершена, сформирован файл с результатами
            </Typography>
          )}
          {status === NotificationStatuses.Failure && (
            <Typography component="p" sx={{ marginTop: '8px' }}>
              {content.error}
            </Typography>
          )}
        </>
      }
    />
  );
};
